import { PageWrapperProps } from "@/components/page-wrapper/types";
import { FC } from "react";
import styles from "./styles.scss";
import clsx from "clsx";

export const PageWrapper: FC<PageWrapperProps> = ({
  children,
  extraContent,
  title,
  className,
  extraContentClassName,
  pageWrapperTitleClassName,
  pageWrapperContentClassName,
  pageTitleClassName,
  pageClassName,
}) => {
  return (
    <div className={clsx(styles.pageWrapper, className)}>
      <div className={clsx(styles.pageWrapperTitle, pageWrapperTitleClassName)}>
        <div className={clsx(styles.pageTitle, pageTitleClassName)}>
          {title}
        </div>
      </div>

      {extraContent && (
        <div className={extraContentClassName}>{extraContent}</div>
      )}

      <div
        className={clsx(styles.pageWrapperContent, pageWrapperContentClassName)}
      >
        <div className={clsx(styles.page, pageClassName)}>{children}</div>
      </div>
    </div>
  );
};
